import { render } from "./reservationFilter.vue?vue&type=template&id=c2df6710&scoped=true"
import script from "./reservationFilter.vue?vue&type=script&lang=js"
export * from "./reservationFilter.vue?vue&type=script&lang=js"

import "./reservationFilter.vue?vue&type=style&index=0&id=c2df6710&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2df6710"]])

export default __exports__